import React from "react";

function Updates() {
  return <div>Ultimele Notificari</div>;
}

export default Updates;
